export const LOAD_METRICS_MACHINES = 'LOAD_METRICS_MACHINES/LOAD';
